// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";

export const AddExtraExpands: typeof PopulateApiParameter = (props: any) => {
    if ("apiParameter" in props.parameter) {
        props.apiParameter = props.parameter.apiParameter;
        return;
    }

    /**
     * XNG-Changes
     * Add timestamp to handle "304 Not Modified" cache issue
     */
    props.apiParameter.expand?.push(`time${new Date().getTime()}`);

    /**
     * XNG-Changes
     * Add IsAcceptingQuote
     */
    if (props.parameter.isAcceptQuote) {
        (props.apiParameter as any).isAcceptQuote = true;
    }
};

addToChainAfter(chain, PopulateApiParameter, AddExtraExpands);
